import React from 'react'

type PageLoaderProps = {
    /** Shown to assistive tech and for WebView / remote-debug identification */
    ariaLabel?: string
}

function PageLoader({ ariaLabel = 'Loading, please wait' }: PageLoaderProps) {
    return (
        <div
            id="pageLoader"
            data-trwidget-loader="overlay"
            role="alert"
            aria-busy="true"
            aria-live="polite"
            aria-label={ariaLabel}
        >
            <div id="pageLoaderSpinner" className="spinner-border text-success" role="status">
                <span className="sr-only">{ariaLabel}</span>
            </div>
        </div>
    )
}

export default PageLoader
